import { ReactElement } from 'react'
import {
  PageWrapper,
  SectionTitle,
  SubHeader,
  CardWrapper,
  Input,
  Button,
  Badge
} from '../../../../../components'
import strings from '../../../../../locale/en'
import { useHistory } from 'react-router-dom'
import { H3, Body } from '../../../../../typography'
import { FlexWrapper } from './subcomponents'

const Tests = (): ReactElement => {
  const {
    menu: {
      admin: {
        createTest: { evaluate, awardedMarks, maximumMarks, timeTaken }
      }
    },
    button: { done }
  } = strings
  const history = useHistory()

  return (
    <PageWrapper id="container">
      <SectionTitle title={evaluate} />
      <SubHeader
        title={'Student name'}
        subTitle={'Test Name'}
        handleBack={() => {
          history.goBack()
        }}
      />
      <CardWrapper>
        <FlexWrapper hasBorder>
          <H3 hasPadding>Question 1</H3>
        </FlexWrapper>
        <FlexWrapper hasBorder>
          <Input
            value={''}
            inputType="text"
            label={awardedMarks}
            placeholder={awardedMarks}
            onChange={() => {}}
            width="20%"
          />
          <Badge title={maximumMarks} subTitle="0 Marks" width="15%"></Badge>
          <Badge title={timeTaken} subTitle="60 Mins" width="25%"></Badge>
        </FlexWrapper>
        <FlexWrapper hasBorder>
          <Body>Question details</Body>
        </FlexWrapper>
        <FlexWrapper hasBorder>
          <div>
            <Body>Answer:</Body>
            <Body>A) Pharynx</Body>
          </div>
        </FlexWrapper>
        <FlexWrapper justifyContent="center">
          <Button>{done}</Button>
        </FlexWrapper>
      </CardWrapper>
    </PageWrapper>
  )
}

export default Tests
